import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.88579 8.53595C3.62953 8.04672 3.02518 7.85786 2.53595 8.11413C2.04672 8.37039 1.85786 8.97474 2.11413 9.46397C2.60982 10.4103 3.26362 11.3664 4.07615 12.2369L2.29289 14.0201C1.90237 14.4107 1.90237 15.0438 2.29289 15.4344C2.68342 15.8249 3.31658 15.8249 3.70711 15.4344L5.56143 13.58C6.39829 14.2136 7.34943 14.748 8.41522 15.1252L7.75714 17.7575C7.6232 18.2933 7.94896 18.8362 8.48475 18.9702C9.02055 19.1041 9.56348 18.7783 9.69743 18.2425L10.3563 15.6072C10.882 15.6856 11.4299 15.7272 12 15.7272C12.5701 15.7272 13.118 15.6856 13.6437 15.6072L14.3026 18.2425C14.4365 18.7783 14.9795 19.1041 15.5152 18.9702C16.051 18.8362 16.3768 18.2933 16.2429 17.7575L15.5848 15.1252C16.6506 14.7479 17.6017 14.2135 18.4385 13.58L20.2929 15.4344C20.6834 15.8249 21.3166 15.8249 21.7071 15.4344C22.0976 15.0438 22.0976 14.4107 21.7071 14.0201L19.9238 12.2368C20.7363 11.3663 21.3901 10.4103 21.8858 9.46397C22.1421 8.97474 21.9532 8.37039 21.464 8.11413C20.9747 7.85786 20.3704 8.04672 20.1141 8.53595C18.7274 11.1833 16.0155 13.7272 12 13.7272C7.98444 13.7272 5.2725 11.1833 3.88579 8.53595Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.00049 5.73789C2.8557 5.46147 2.51424 5.35477 2.23783 5.49956C1.96141 5.64435 1.85471 5.9858 1.9995 6.26222C2.30698 6.84924 2.7143 7.44201 3.22182 7.97921L2.10048 9.10054C1.87984 9.32119 1.87984 9.67893 2.10048 9.89957C2.32113 10.1202 2.67887 10.1202 2.89951 9.89957L4.0612 8.73789C4.58706 9.14086 5.18799 9.4793 5.86422 9.71354L5.45188 11.3629C5.3762 11.6656 5.56025 11.9724 5.86298 12.0481C6.1657 12.1238 6.47246 11.9397 6.54814 11.637L6.96091 9.98588C7.29264 10.0375 7.63899 10.0651 7.99999 10.0651C8.361 10.0651 8.70735 10.0375 9.03908 9.98588L9.45186 11.637C9.52754 11.9397 9.8343 12.1238 10.137 12.0481C10.4397 11.9724 10.6238 11.6656 10.5481 11.3629L10.1358 9.71353C10.812 9.47929 11.4129 9.14086 11.9388 8.73788L13.1005 9.89957C13.3211 10.1202 13.6789 10.1202 13.8995 9.89957C14.1202 9.67893 14.1202 9.32119 13.8995 9.10054L12.7782 7.9792C13.2857 7.442 13.693 6.84924 14.0005 6.26222C14.1453 5.9858 14.0386 5.64435 13.7622 5.49956C13.4857 5.35477 13.1443 5.46147 12.9995 5.73789C12.1468 7.36569 10.4763 8.93505 7.99999 8.93505C5.52372 8.93505 3.85314 7.36569 3.00049 5.73789Z"
  />
);

export const VisibilityOffIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="VisibilityOff" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
